<script lang="ts">
	import { format } from 'svelte-i18n';
	import { os, ios_version, android_version } from 'src/stores/session/native-bridge';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { Text, ButtonV2, Button } from '@Shelly/shelly-design-system';
	import { openExternalLink } from 'src/helpers/utilities';

	const IOS_STORE_URL = 'https://apps.apple.com/us/app/shelly-smart-control/id1660045967';
	const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=cloud.shelly.smartcontrol';

	$: ButtonComponent = $showNewLayout ? ButtonV2 : Button;
	$: isIOS = $os === 'IOS';
	// Native app version parsed from the userAgent at init (e.g. "1.51.24").
	$: appVersion = isIOS ? $ios_version : $android_version;
	$: storeUrl = isIOS ? IOS_STORE_URL : ANDROID_STORE_URL;
	$: storeButtonLabel = $format('button_go_to_store', { default: 'Go to Store' });
</script>

<div class="d-flex align-items-center">
	<div class="d-flex align-items-center min-width-0 flex-1">
		<Text class="width-full" element="p" styleType="body" noWrap>
			{appVersion}
		</Text>
	</div>
	<svelte:component
		this={ButtonComponent}
		variant="secondary"
		size="m"
		icon="fa-regular fa-arrow-up-right-from-square"
		aria-label={storeButtonLabel}
		on:click={() => openExternalLink(storeUrl)}
	>
		{storeButtonLabel}
	</svelte:component>
</div>
